<div class="invite-description">
  {{ translationKey + 'description' | translate: { name: persona?.name } }}
</div>
<a
  seFeLink="low"
  class="invite-link"
  href="https://help.sportsengine.com/en/articles/11164312-what-is-guardianship"
  target="_blank">
  {{ translationKey + "BUTTONS.learn_more" | translate }}
</a>
<div class="invite-form">
  <se-po-add-guardian #addGuardian></se-po-add-guardian>
</div>
<se-fe-button class="invite-button"
  seFeDataEmphasis="high"
  [seFeDataFullWidth]="true"
  (click)="onInvite()">
  {{ translationKey + 'BUTTONS.send' | translate }}
</se-fe-button>
<se-fe-button class="invite-button"
  [seFeDataFullWidth]="true"
  (click)="onSkip()">
  {{ translationKey + 'BUTTONS.skip' | translate }}
</se-fe-button>
